import Step from "@frog/source/models/Step.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"

export default {
    "affiliation": "good",
    "party": {
        "units": {
            "priest": {
                "key": "priest",
                "title": "The Priest",
                // "subtitle": "with the Crucifix",
                "imageKey": "priest",
                "color": "#0069bc",

                "affiliation": "good",
                "isRecruited": true,

                "jobKey": "nobody",
                "maxhealth": 40,
                "moverange": 2,
                "defense": 0,
                "resistance": 0,
                "skillKeys": [
                    "restore-health",
                ],
                "primaryItem": {
                    "name": "Crucifix",
                    "element": "water",
                    "attacktype": "magic",
                    "attackrange": 1,
                    "power": 20,
                    "skillKeys": ["inflict-damage"],
                    "weaponImageKey": "horror-crucifix",
                    "weaponAudioKey": "Unit:Attack:Crucifix",
                },

                "scripts": {
                    "death": [
                        (stage) => {
                            if(stage.flags["PriestDied"] != true) {
                                return [
                                    PlotSteps.PlayStinger("Unit:Death:Knell"),
                                    "THE PRIEST HAS DIED",
                                    "PRIEST: May the lord have m-mercy on our souls.",
                                    Step.flag("PriestDied", true),
                                ]
                            }
                        },
                    ]
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/horror-tactics/portraits/thepriest.png"),
                },
            },
            "occultist": {
                "key": "occultist",
                "title": "The Lady",
                // "subtitle": "with the Knife",
                "imageKey": "occultist",
                "color": "#800008",

                "affiliation": "good",
                "isRecruited": true,

                "jobKey": "nobody",
                "maxhealth": 40,
                "moverange": 2,
                "defense": 0,
                "resistance": 0,
                "skillKeys": [
                    "push",
                ],
                "primaryItem": {
                    "name": "Knife",
                    "element": "fire",
                    "attacktype": "steel",
                    "attackrange": 1,
                    "power": 20,
                    "skillKeys": ["inflict-damage"],
                    "weaponImageKey": "horror-knife",
                    "weaponAudioKey": "Unit:Attack:Knife",
                },

                "scripts": {
                    "death": [
                        (stage) => {
                            if(stage.flags["OccultistDied"] != true) {
                                return [
                                    PlotSteps.PlayStinger("Unit:Death:Knell"),
                                    "THE LADY HAS DIED",
                                    "OCCULTIST: How exquisite.",
                                    Step.flag("OccultistDied", true),
                                ]
                            }
                        }
                    ]
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/horror-tactics/portraits/theoccultist.png"),
                },
            },
            "professor": {
                "key": "professor",
                "title": "The Professor",
                // "subtitle": "with the Revolver",
                "imageKey": "professor",
                "color": "#bb3806",

                "affiliation": "good",
                "isRecruited": true,

                "jobKey": "nobody",
                "maxhealth": 40,
                "moverange": 2,
                "defense": 0,
                "resistance": 0,
                "skillKeys": [
                    "pull",
                ],
                "primaryItem": {
                    "name": "Revolver",
                    "element": "earth",
                    "attacktype": "steel",
                    "attackrange": 2,
                    "power": 20,
                    "skillKeys": ["inflict-damage"],
                    "weaponImageKey": "horror-gun",
                    "weaponAudioKey": "Unit:Attack:Revolver",
                },

                "scripts": {
                    "death": [
                        (stage) => {
                            if(stage.flags["ProfessorDied"] != true) {
                                return [
                                    PlotSteps.PlayStinger("Unit:Death:Knell"),
                                    "THE PROFESSOR HAS DIED",
                                    "PROFESSOR: This - this doesn't make any sense, I-",
                                    Step.flag("ProfessorDied", true),
                                ]
                            }
                        },
                    ]
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/horror-tactics/portraits/theprofessor.png"),
                },
            },
            "artist": {
                "key": "artist",
                "title": "The Host",
                "imageKey": "artist",
                "color": "#296c88",
                // "color": "#82000a",

                "affiliation": "bad",
                "isRecruited": false,

                "maxhealth": 70,
                "moverange": 1,
                "defense": 0,
                "resistance": 0,
                "primaryItem": {
                    "name": "Sword",
                    "element": "fire",
                    "attacktype": "steel",
                    "attackrange": 1,
                    "power": 20,
                    "skillKeys": ["inflict-damage"],
                    "weaponImageKey": "hidden",
                    "weaponAudioKey": "Unit:Attack:Monster",
                },

                "scripts": {
                    "death": [
                        PlotSteps.KillAudio({"label": "music"}),
                        PlotSteps.PlayStinger("Unit:Death:Knell"),
                        PlotSteps.Wait(1000),
                        "ARTIST: How rude!",
                        "ARTIST: Where are your manners?",
                        (stage) => {
                            return Object.values(stage.units).map((unit) => {
                                if(unit.spotTag == "warning"
                                || unit.affiliation == "bad") {
                                    return Step.deltastage({
                                        "unit": {
                                            "key": unit.key,
                                            "isDead": true,
                                        }
                                    })
                                }
                            })
                        }
                    ]
                },
                "portraits": {
                    "neutral": require("@frog/source/assets/images/horror-tactics/portraits/theartist-bored.png"),
                    "smile": require("@frog/source/assets/images/horror-tactics/portraits/thehost-smile.png"),
                    "transformed": require("@frog/source/assets/images/horror-tactics/portraits/thehost-transformed.png"),
                },
            },
        }
    },
}
